import { ROUTES } from '@ab-core/functions';
import type { LinkProps } from '@ab-core/link';
import { Link } from '@ab-core/link';
import useText from '@ab-core/localization/src/useText';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';

const PLACEHOLDER_SPLITT = '$placeholder';

export type TabInfoTextProps = {
    onClose: DefaultTabTextProps['onClose'];
};

export const CartInfoText: FC<TabInfoTextProps> = ({ onClose }) => {
    const productAddToCartZeroState = useText('cartList.productAddToCartZeroState').split(PLACEHOLDER_SPLITT);
    const productAddToCartLinktextZeroState = useText('cartList.productAddToCartLinktextZeroState');
    const infoTextCart = useText('cartList.addToCartModalInfo');

    return (
        <DefaultTabText
            infoText={infoTextCart}
            beforeLinkText={productAddToCartZeroState[0]}
            linkTo={ROUTES.CARTS}
            linkText={productAddToCartLinktextZeroState}
            afterLinkText={productAddToCartZeroState[1]}
            onClose={onClose}
        />
    );
};

export const ShoppinglistInfoText: FC<TabInfoTextProps> = ({ onClose }) => {
    const productAddToListZeroState = useText('shoppingList.productAddToListZeroState').split(PLACEHOLDER_SPLITT);
    const productAddToListLinktextZeroState = useText('shoppingList.productAddToListLinktextZeroState');
    const infoTextList = useText('shoppingList.productAddedToListModalInfo');

    return (
        <DefaultTabText
            infoText={infoTextList}
            beforeLinkText={productAddToListZeroState[0]}
            linkTo={ROUTES.SHOPPINGLISTS}
            linkText={productAddToListLinktextZeroState}
            afterLinkText={productAddToListZeroState[1]}
            onClose={onClose}
        />
    );
};

type DefaultTabTextProps = {
    infoText: string;
    beforeLinkText: string;
    linkText: string;
    afterLinkText: string;
    linkTo: LinkProps['to'];
    onClose: LinkProps['onClick'];
};

const DefaultTabText: FC<DefaultTabTextProps> = (props) => {
    const { infoText, beforeLinkText, afterLinkText, linkText, linkTo, onClose } = props;

    return (
        <div className="flex flex-wrap-wrap">
            <Text color="gray50">{infoText}</Text>
            <Text color="gray50">
                {beforeLinkText}
                <Link onClick={onClose} to={linkTo}>
                    {linkText}
                </Link>
                {afterLinkText}
            </Text>
        </div>
    );
};
